<template>
  <div class="senior_wrap">
    <div class="taxation_title">
      <h2>智能财税高级</h2>
    </div>
    <ul v-if="productFlag == 3" class="taxation_item">
      <!-- 大数据 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:dsj')">
        <img
          src="../img/dsj-logo.png"
          alt=""
          class="app_logo"
          style="height: 30px"
        />
        <img src="../img/ctx-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySys('dsj')">进入系统</el-button>
      </li>
      <!-- 绩效管理 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:jxgl')">
        <img
          src="../img/jxgl-logo.png"
          alt=""
          class="app_logo"
          style="height: 24px"
        />
        <img src="../img/ptx-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySys('jxgl')">进入系统</el-button>
      </li>
      <!-- 预算管理 2.0 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:ysgl')">
        <img
          src="../img/ysgl-logo.png"
          alt=""
          class="app_logo"
          style="height: 24px"
        />
        <img src="../img/jss-bg.png" alt="" class="app_bg" />
        <span class="text">（2.0）</span>
        <el-button @click="entrySys('ysgl')">进入系统</el-button>
      </li>
      <!-- 成本管理(管理会计) 1.0 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:cbgl')">
        <img
          src="../img/cbgl-logo.png"
          alt=""
          class="app_logo"
          style="height: 24px"
        />
        <img src="../img/zwfz-bg.png" alt="" class="app_bg" />
        <span class="text">（1.0）</span>
        <el-button @click="entrySys('glkj')">进入系统</el-button>
      </li>
      <!--
        李萌改版 2021-3-11
        智能发票
        智能纳税申报
        税务仿真平台
        税务风险管理
      -->
      <!-- 智能发票  由 票天下 中级 改名而来 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:znfp')">
        <img src="../img/znfp-logo.png" alt="" class="app_logo" />
        <img src="../img/znfp-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySysDefault('ptx')">进入系统</el-button>
      </li>
      <!-- 智能纳税申报  由 金税师 中级 改名而来 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:znnssb')">
        <img src="../img/znnssb-logo.png" alt="" class="app_logo" />
        <img src="../img/zncssb-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySysDefault('jss')">进入系统</el-button>
      </li>
      <!-- 税务仿真平台 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:swfzpt')">
        <img src="../img/swfzpt-logo.png" alt="" class="app_logo" />
        <img src="../img/swfzpt-bg.png" alt="" class="app_bg" />
        <el-button @click="showDialog('swfzpt')">进入系统</el-button>
      </li>
      <!-- 税务风险管理 -->
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:swfxgl')">
        <img src="../img/swfxgl-logo.png" alt="" class="app_logo" />
        <img src="../img/swfxgl-bg.png" alt="" class="app_bg" />
        <el-button @click="showDialog('swfxgl')">进入系统</el-button>
      </li>
    </ul>

    <!-- 智能发票 && 智能纳税申报 dialog -->
    <el-dialog :visible.sync="centerDialogVisible" width="400px" center>
      <div class="cont">
        <p>请选择您要进入的案例公司：</p>
        <ul>
          <li
            :class="{ active: index === curId }"
            v-for="(item, index) in companyList"
            :key="index"
            @click="tabClick(item, index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>

    <!-- 税务仿真平台 && 税务风险管理 dialog -->
    <el-dialog :visible.sync="linkDialogVisible" width="420px" center>
      <div class="cont">
        <ul style="width: 185px">
          <li
            :class="{ active: index === curIndex }"
            v-for="(item, index) in linkList"
            :key="index"
            @click="linkTabClick(item, index)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import crypto from "crypto";
import * as userApi from "../../../../api/userApi";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      // isTest: false,
      sysUserPermissionList:
        JSON.parse(localStorage.getItem("sysUserPermissionList")) || [], // 权限对象
      userType: sessionStorage.getItem("userType"), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem("productFlag"),
      centerDialogVisible: false,
      companyList: [
        { name: "北京神龙贸易有限公司", code: "BJ009312", tcode: "001" },
        { name: "北京星晨办公用品有限公司", code: "BJ009319", tcode: "002" },
        { name: "杭州康健医疗器械有限公司", code: "BJ009321", tcode: "003" },
        { name: "北京乐嘉食品有限责任公司", code: "BJ013145", tcode: "004" },
      ],
      curId: null,
      sys: "",
      linkDialogVisible: false,
      linkList: [],
      curIndex: null,
    };
  },
  created() {
    // this.isTest = (process.env.NODE_ENV=='development' || process.env.NODE_ENV=='uat') ? true : false
    if (this.userType == 2 || this.userType == 3) {
      this.isStudent = true;
    } else {
      this.isStudent = false;
    }
  },
  methods: {
    setSha1(url, secretKey) {
      // 加密
      let hmac = crypto.createHmac("sha1", secretKey || "123456");
      hmac.update(url);
      return hmac.digest("hex");
    },
    zljtLogin(params) {
      let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`;
      return axios.post(src, params).then((rs) => rs);
    },
    entrySys(sys) {
      let that = this;
      if (localStorage.getItem("Authorization")) {
        userApi
          .isExpired(localStorage.getItem("Authorization"))
          .then((rs) => {
            if (rs.code == 0 && rs.data == 0) {
              if (sys == "dsj") {
                // 大数据
                let userId = sessionStorage.getItem("userId");
                let token = localStorage.getItem("Authorization");
                let data = {
                  grant_type: "password",
                  username: token,
                  password: token,
                  matchPlanId: userId + "9999",
                  planMajor: 2, //专业   0 默认   1	智能审计    2  智能财税   3  智能估值  7  管理会计  8	社交电商
                  tenant_path: "/中联教育/智能财税",
                  orgId: "智能财税应用中心数据源",
                  "callBackUrl": process.env.BASE_API + "/api-user/sys/user/get",
                }
                axios({
                  url: `${process.env.DSJ_API}/connect/token`,
                  method: "post",
                  data: qs.stringify(data),
                  headers: {
                    'Authorization': 'Basic aW50ZWdyYXRpb246ZXVuR0thczNQcWQ2Rk13eDllVXBkUzd4bXo=',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                  }
                }).then((rs) => {
                  let href =
                    process.env.DSJ_API +
                    "/integration/?token=" +
                    rs.data.access_token;
                  window.open(href, "_blank");
                  this.loading = false;
                });
              } else if (sys == "glkj") {
                // 成本管理(管理会计)

                let userId = sessionStorage.getItem("userId");
                let courseId = userId + "8888";
                let classId = userId + "9999";
                let qstId =
                  process.env.NODE_ENV == "development" ||
                  process.env.NODE_ENV == "uat"
                    ? 999998888
                    : 77938;
                let clientId = "1349883712819109890";
                let encrypted = `TEACH_${courseId}_${classId}_2_NONE`;
                let identity = "glkjzh";
                let item = "27011201-6fe9-46b4-ba7f-fe241aed2132";
                let roleCodes = "3036";
                let templateCode = "GENERAL034";
                let timestamp = new Date().getTime();
                let token = localStorage.getItem("Authorization");
                let userType = sessionStorage.getItem("userType");
                let username = sessionStorage.getItem("userName");
                let nickname = sessionStorage.getItem("loginName");
                let deptId = sessionStorage.getItem("deptId");
                let deptName = sessionStorage.getItem("deptName");
                let mobile = sessionStorage.getItem("mobile");
                let name = Base64.encode(nickname);

                let host = process.env.VUE_APP_ONLINEEXCEL;

                // 加密参数
                let shanStr = `{clientId=${clientId}, encrypted=${encrypted}, identity=${identity}, item=${item}, qstId=${qstId}, roleCode=${roleCodes}, templateCode=${templateCode}, timeStamp=${timestamp}, token=${token}, userType=${userType}, username=${username}}`;
                let secretKey = that.setSha1(
                  shanStr,
                  "02424D4FD04A007E453DADA28E4EEE37"
                );
                let glkjParams = {
                  clientId: clientId,
                  encrypted: encrypted,
                  identity: identity,
                  item: item,
                  qstId: qstId,
                  roleCode: roleCodes,
                  sign: secretKey,
                  templateCode: templateCode,
                  timeStamp: timestamp,
                  token: token,
                  userId: userId,
                  userType: userType,
                  username: username,
                };

                that.zljtLogin(glkjParams).then((rs) => {
                  if (rs.data.code == 0) {
                    let jumpStr = `isHide=1&parentPlatform=managementAccount&token=${rs.data.data.access_token}&userId=${userId}&questionId=${qstId}&platform=managementAccountCH&sysId=GLKJ&keyId=${userId}&templateCode=GENERAL034&orgId=${deptId}&orgName=${deptName}&encrypted=${encrypted}&mobile=${mobile}&identity=glkjzh&roleCodes=3036&nickname=${nickname}`;
                    let src = `${host}/#home?${jumpStr}`;
                    window.open(src);
                  } else {
                    that.$messageError(rs.data.msg);
                  }
                });
              } else if (sys == "jxgl" || sys == "ysgl") {
                this.handleFunc(sys);
              } else {
                this.loading = false;
                this.$messageWarning("暂无权限，请联系管理员！");
              }
            } else {
              this.$router.push({ path: "/home" });
              this.$messageError("登录已过期，请重新登录");
              localStorage.removeItem("Authorization");
              localStorage.removeItem("isbinding");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.loading = false;
        this.$router.push({ path: "/home" });
      }
    },
    // 绩效 & 预算 跳转
    handleFunc(type) {
      let that = this;
      // type jxgl / ysgl
      let userId = sessionStorage.getItem("userId");
      let courseId = userId + "8888";
      let classId = userId + "9999";
      let qstId = 1;
      let clientId = "1349883712819109890";
      let encrypted = `TEACH_${courseId}_${classId}_2_NONE`;
      let identity = "jixiaozh";
      let item = "27011201-6fe9-46b4-ba7f-fe241aed2132";
      let roleCodes = type == "jxgl" ? "JXGLY" : "YSZG";
      let templateCode = "001";
      let timestamp = new Date().getTime();
      let token = localStorage.getItem("Authorization");
      let userType = sessionStorage.getItem("userType");
      let username = sessionStorage.getItem("userName");
      let nickname = sessionStorage.getItem("loginName");
      let deptId = sessionStorage.getItem("deptId");
      let deptName = sessionStorage.getItem("deptName");
      let mobile = sessionStorage.getItem("mobile");
      let name = Base64.encode(nickname);
      let host = process.env.JIXIAO_API;

      // 加密参数
      let shanStr = `{clientId=${clientId}, encrypted=${encrypted}, identity=${identity}, item=${item}, qstId=${qstId}, roleCode=${roleCodes}, templateCode=${templateCode}, timeStamp=${timestamp}, token=${token}, userType=${userType}, username=${username}}`;
      let secretKey = that.setSha1(shanStr, "02424D4FD04A007E453DADA28E4EEE37");
      let params = {
        clientId: clientId,
        encrypted: encrypted,
        identity: identity,
        item: item,
        qstId: qstId,
        roleCode: roleCodes,
        sign: secretKey,
        templateCode: templateCode,
        timeStamp: timestamp,
        token: token,
        userId: userId,
        userType: userType,
        username: username,
      };

      that.zljtLogin(params).then((rs) => {
        if (rs.data.code == 0) {
          let jumpStr = `token=${rs.data.data.access_token}`;
          let src = `${host}/#/login-sso?${jumpStr}`;
          window.open(src);
        } else {
          that.$messageError(rs.data.msg);
        }
      });
    },

    // 原先 票天下 中级 && 金税师 中级 跳转
    entrySysDefault(sys) {
      if (localStorage.getItem("Authorization")) {
        let param = {
          productCode: "ctx",
          productLevel: 2,
        };
        userApi.intoSysJudge(param).then((res) => {
          if (res.code == 0) {
            this.sys = sys;
            if (
              res.data.length < this.companyList.length &&
              (sys == "ctx" || sys == "ptx" || sys == "jss" || sys == "gxl")
            ) {
              this.centerDialogVisible = true;
              this.curId = null;
            } else {
              userApi
                .isExpired(localStorage.getItem("Authorization"))
                .then((rs) => {
                  if (rs.code == 0 && rs.data == 0) {
                    if (
                      sys == "ctx" ||
                      sys == "ptx" ||
                      sys == "jss" ||
                      sys == "gxl"
                    ) {
                      let userType = this.userType;
                      var tmpWin = window.open();
                      tmpWin.document.open();
                      tmpWin.document.write("跳转中，请稍后。。。");
                      tmpWin.document.close();
                      let phone = sessionStorage.getItem("mobile");
                      let name = sessionStorage.getItem("loginName");
                      let schoolId = sessionStorage.getItem("deptId");
                      let schoolName = sessionStorage.getItem("deptName");
                      let time = new Date().getTime() + "";
                      let userId = sessionStorage.getItem("userId");
                      let classId = "";
                      let courseId = "";
                      classId = sessionStorage.getItem("userId") + "888812345";
                      courseId = sessionStorage.getItem("deptId") + "888812345";

                      let url =
                        "classId=" +
                        classId +
                        "&className=智能财税中级师资研修班&courseId=" +
                        courseId +
                        "&mobile=" +
                        phone +
                        "&nickName=" +
                        name +
                        "&platform=" +
                        sys +
                        "&questionId=999998888&schoolId=" +
                        schoolId +
                        "&schoolName=" +
                        schoolName +
                        "&time=" +
                        time +
                        "&userId=" +
                        userId +
                        "&userType=" +
                        userType;
                      let sha1sign = this.setSha1(url);
                      let templates = "";
                      if (process.env.hostStr == "zledusx") {
                        templates = "BJ009312,BJ009319,BJ009321,BJ013145";
                      } else {
                        templates = "001,002,003,004,005";
                      }
                      let stxObj = {
                        courseId: courseId,
                        classId: classId,
                        className: "智能财税中级师资研修班",
                        mobile: phone,
                        nickName: name,
                        platform: sys,
                        questionId: "999998888",
                        schoolId: schoolId,
                        schoolName: schoolName,
                        templates: templates,
                        time: time,
                        userId: userId,
                        userType: this.userType,
                        sign: sha1sign,
                      };
                      axios
                        .post(process.env.STX_API, qs.stringify(stxObj))
                        .then((res) => {
                          if (res.data.result) {
                            tmpWin.location = res.data.value;
                            this.loading = false;
                          } else {
                            this.$messageError(res.data.error.message);
                            tmpWin.document.open();
                            tmpWin.document.write(res.data.error.message);
                            tmpWin.document.close();
                            this.loading = false;
                          }
                        })
                        .catch((err) => {
                          tmpWin.document.open();
                          if (err.code == "401") {
                            tmpWin.document.write("登录已过期，请重新登录");
                            tmpWin.location.href = process.env.BASE_API;
                          } else {
                            tmpWin.document.write("接口访问异常" + err.code);
                          }
                          tmpWin.document.close();
                          this.loading = false;
                        });
                    } else if (sys == "zwfz") {
                      let href =
                        process.env.DUMMY_API +
                        "/#/patentApply?token=" +
                        localStorage.getItem("Authorization") +
                        "&questionId=999998888&courseId=99999999&classId=999998888&type=1&degree=intermediate&userName=" +
                        sessionStorage.getItem("loginName") +
                        "&shwoMenu=true";
                      window.open(href, "_blank");
                      this.loading = false;
                    } else {
                      this.loading = false;
                      this.$messageWarning("暂无权限，请联系管理员！");
                    }
                  } else {
                    this.$router.push({ path: "/home" });
                    this.$messageError("登录已过期，请重新登录");
                    localStorage.removeItem("Authorization");
                    localStorage.removeItem("isbinding");
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        });
      } else {
        this.loading = false;
        this.$router.push({ path: "/home" });
      }
    },
    tabClick(item, i) {
      this.curId = i;
      let code = "";
      if (process.env.hostStr == "zledusx") {
        code = item.code;
      } else {
        code = item.tcode;
      }
      let param = {
        productCode: "ctx",
        productLevel: 2,
        templateCode: code,
      };
      userApi.selectSysJudge(param).then((res) => {
        console.log(res);
        if (res.code == 0) {
          userApi
            .isExpired(localStorage.getItem("Authorization"))
            .then((rs) => {
              if (rs.code == 0 && rs.data == 0) {
                if (
                  this.sys == "ctx" ||
                  this.sys == "ptx" ||
                  this.sys == "jss" ||
                  this.sys == "gxl"
                ) {
                  let userType = this.userType;
                  // let deptIdArr = ['129','134','13','516','653','648']
                  // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
                  //   this.$messageWarning('暂未开放')
                  //   this.loading = false
                  //   return
                  // }
                  // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
                  //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
                  //   this.loading = false
                  //   return
                  // }
                  var tmpWin = window.open();
                  tmpWin.document.open();
                  tmpWin.document.write("跳转中，请稍后。。。");
                  tmpWin.document.close();
                  let phone = sessionStorage.getItem("mobile");
                  let name = sessionStorage.getItem("loginName");
                  let schoolId = sessionStorage.getItem("deptId");
                  let schoolName = sessionStorage.getItem("deptName");
                  let time = new Date().getTime() + "";
                  let userId = sessionStorage.getItem("userId");
                  let classId = "";
                  let courseId = "";
                  classId = sessionStorage.getItem("userId") + "8888";
                  courseId = sessionStorage.getItem("deptId") + "8888";

                  let url =
                    "classId=" +
                    classId +
                    "&className=智能财税中级师资研修班&courseId=" +
                    courseId +
                    "&mobile=" +
                    phone +
                    "&nickName=" +
                    name +
                    "&platform=" +
                    this.sys +
                    "&questionId=999998888&schoolId=" +
                    schoolId +
                    "&schoolName=" +
                    schoolName +
                    "&time=" +
                    time +
                    "&userId=" +
                    userId +
                    "&userType=" +
                    userType;
                  let sha1sign = this.setSha1(url);
                  let templates = code;
                  // if(process.env.hostStr=='zledusx'){
                  //   templates = "BJ009312,BJ009319,BJ009321,BJ013145"
                  // }else{
                  //   templates = "001,002,003,004,005"
                  // }
                  let stxObj = {
                    courseId: courseId,
                    classId: classId,
                    className: "智能财税中级师资研修班",
                    mobile: phone,
                    nickName: name,
                    platform: this.sys,
                    questionId: "999998888",
                    schoolId: schoolId,
                    schoolName: schoolName,
                    templates: templates,
                    time: time,
                    userId: userId,
                    userType: this.userType,
                    sign: sha1sign,
                  };
                  axios
                    .post(process.env.STX_API, qs.stringify(stxObj))
                    .then((res) => {
                      if (res.data.result) {
                        tmpWin.location = res.data.value;
                        this.loading = false;
                      } else {
                        this.$messageError(res.data.error.message);
                        tmpWin.document.open();
                        tmpWin.document.write(res.data.error.message);
                        tmpWin.document.close();
                        this.loading = false;
                      }
                    })
                    .catch((err) => {
                      tmpWin.document.open();
                      if (err.code == "401") {
                        tmpWin.document.write("登录已过期，请重新登录");
                        tmpWin.location.href = process.env.BASE_API;
                      } else {
                        tmpWin.document.write("接口访问异常" + err.code);
                      }
                      tmpWin.document.close();
                      this.loading = false;
                    });
                } else if (this.sys == "zwfz") {
                  let href =
                    process.env.DUMMY_API +
                    "/#/patentApply?token=" +
                    localStorage.getItem("Authorization") +
                    "&questionId=999998888&courseId=99999999&classId=999998888&type=1&degree=intermediate&userName=" +
                    sessionStorage.getItem("loginName");
                  window.open(href, "_blank");
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.$messageWarning("暂无权限，请联系管理员！");
                }
              } else {
                this.$router.push({ path: "/home" });
                this.$messageError("登录已过期，请重新登录");
                localStorage.removeItem("Authorization");
                localStorage.removeItem("isbinding");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    // 税务仿真平台 && 税务风险管理
    showDialog(sys) {
      this.curIndex = null
      this.linkList = sys == "swfzpt" ? [
        "电子税务局", "自然人电子税务局（扣缴端）", "增值税发票综合服务平台", "区块链发票查询"
      ] : sys == "swfxgl" ? [
        "大数据税务风险预警", "税务风险检查", "企业税务优化",
      ] : []
      this.linkDialogVisible = true
    },
    linkTabClick(str, i) {
      let that = this
      this.curIndex = i
      let myClass = null   // 0-税务仿真平台   1-税务风险管理
      // 参数
      let userId = sessionStorage.getItem("userId");
      let courseId = userId + "8888";
      let classId = userId + "9999";
      let clientId = "1349883712819109890"
      let encrypted = `TEACH_${courseId}_${classId}_2_NONE`;
      let item = "27011201-6fe9-46b4-ba7f-fe241aed2132"
      let timeStamp = new Date().getTime()
      let token = localStorage.getItem("Authorization");
      let userType = sessionStorage.getItem("userType");
      let username = sessionStorage.getItem("userName");
      let nickname = sessionStorage.getItem("loginName");
      let deptId = sessionStorage.getItem("deptId");
      let deptName = sessionStorage.getItem("deptName");
      let mobile = sessionStorage.getItem("mobile");
      let name = Base64.encode(nickname);

      let identity = ""
      let qstId = ""
      let roleCode = ""
      let stxUrl = ""
      let templateCode = ""
      let host = ""
      // 税务仿真平台
      if (str === "电子税务局") {
        // myClass = 0
        // qstId = 75135
        // host = process.env.FZBS_URL
        //
        // // https://slpt.cailian.net/?clientId=1349883712819109890&userCode=9302&examType=4&examPlan=151771&orgId=1&paperCode=null&qstId=75135&courseId=1897&classId=151771&teamId=null&roleCode=8888&timestamp=1646972490250&questionCode=27011201-6fe9-46b4-ba7f-fe241aed2132&token=6afd0d5b-87fa-4872-8cdc-8032110724dc&sign=b0d2946b8100c9eabe22dadc0e727abb
        // let jumpStr = `clientId=${clientId}&userCode=${userId}&examType=4&examPlan=151771&orgId=${deptId}&paperCode=null&qstId=${qstId}&courseId=1897&classId=151771&teamId=null&roleCode=${roleCode}&timestamp=${timeStamp}&questionCode=27011201-6fe9-46b4-ba7f-fe241aed2132&token=${token}&sign=${sign}`;
        // let src = `${host}/?${jumpStr}`;
        // window.open(src);
        // return

        myClass = 0
        identity = "FZBAOSHUI"
        qstId = 75135
        roleCode = "3002"
        templateCode = "0987"
        host = process.env.FZBS_URL

      } else if (str === "自然人电子税务局（扣缴端）") {
        myClass = 0
        identity = "ChinaGovTaxApply"
        qstId = 77628
        roleCode = "3002"
        stxUrl = "https://ctxsxapi.cailian.net"
        templateCode = "0987"
        host = process.env.ZRR_DZSWJ_API2
      } else if (str === "增值税发票综合服务平台") {
        myClass = 0
        qstId = 102
        host = process.env.DUMMY_API
        // https://dummyedutest.cailian.net/#/inputTax?token=af7dd743-f3e2-473b-a1e2-4e0bdeb53794&examType=1&courseId=1978&questionId=102&classId=3025&userName=peter
        let jumpStr = `token=${token}&examType=1&courseId=1978&questionId=${qstId}&classId=3025&userName=${username}`;
        let src = `${host}/#/inputTax?${jumpStr}`;
        window.open(src);
        return

      } else if (str === "区块链发票查询") {
        myClass = 0
        qstId = 101
        host = process.env.DUMMY_API
        // https://dummyedutest.cailian.net/#/blockchainInvoice?token=af7dd743-f3e2-473b-a1e2-4e0bdeb53794&examType=1&courseId=1978&questionId=101&classId=3025&userName=peter
        let jumpStr = `token=${token}&examType=1&courseId=1978&questionId=${qstId}&classId=3025&userName=${username}`;
        let src = `${host}/#/blockchainInvoice?${jumpStr}`;
        window.open(src);
        return

      } else
      // 税务风险管理
      if (str === "大数据税务风险预警") {
        myClass = 1
        identity = "SHUIWUFENGXIANfinance"
        qstId = 77451
        roleCode = "8888"
        stxUrl = "https://ctxsxapi.cailian.net"
        templateCode = "202202003NoSTX"
        host = process.env.VUE_APP_ONLINEEXCEL
      } else if (str === "税务风险检查") {
        myClass = 1
        identity = "QIYEZICHAfinance"
        qstId = 77436
        roleCode = "8888"
        stxUrl = "https://ctxsxapi.cailian.net"
        templateCode = "202202003NoSTX"
        host = process.env.VUE_APP_ONLINEEXCEL
      } else if (str === "企业税务优化") {
        myClass = 1
        identity = "NASHUIfinance"
        qstId = 77395
        roleCode = "8888"
        stxUrl = "https://ctxsxapi.cailian.net"
        templateCode = "202202003NoSTX"
        host = process.env.VUE_APP_ONLINEEXCEL
      }

      // 加密参数
      let shanStr = `{clientId=${clientId}, encrypted=${encrypted}, identity=${identity}, item=${item}, qstId=${qstId}, roleCode=${roleCode}, templateCode=${templateCode}, timeStamp=${timeStamp}, token=${token}, userType=${userType}, username=${username}}`;
      let secretKey = that.setSha1(
        shanStr,
        "02424D4FD04A007E453DADA28E4EEE37"
      );
      let sign = secretKey

      let params = {
        clientId, encrypted, identity, item, qstId, roleCode, sign, stxUrl,
        templateCode, timeStamp, token, userType, username
      }
      console.log(params)

      that.zljtLogin(params).then((rs) => {
        if (rs.data.code == 0) {

          if (myClass == 0) {

            if (str === "电子税务局") {
              let param = {
                /* 跳转参数 */
                // classId: "3025",
                clientId: params.clientId,
                // courseId: 1978,
                encrypted: params.encrypted,
                // examType: "4",
                identity: params.identity,
                item: params.item,
                qstId: params.qstId,
                roleCode: params.roleCode,
                sign: params.sign,
                // teamId: "",
                // templateCode: "001",
                timeStamp: params.timeStamp,
                // token: "1ee217a7-47ae-47f8-b519-5410a1909f1d",
                userId: params.userId,
                userType: params.userType,
                username: params.username,

                /* 埋点参数 */
                userCode: params.userId, //	用户唯一ID（与传入的参数userCode对应）
                examType: params.examType, //	类型（与传入的参数examType对应）
                examPlan: params.classId, //	考试计划（与传入的参数examPlan对应）
                paperCode: '', //	试卷id（与传入的参数paperCode对应）
                questionCode: params.qstId, //	试题id（与传入的参数questionId对应）
                courseId: params.courseId, //	课程id（与传入的参数对应）
                classId: params.classId, //	班级id（与传入的参数对应）
                // formName: '', //	事项编码（不为null,为埋点事项字段，单独对接）
                // formMapper: '', //	事项明细（可为null，根据产品设计,为埋点事项字段，单独对接）
                // detailContent: '', //	学生答案（不为null，当signStatus为删除态时可为null）
                templateCode: params.templateCode, //	账套模板编码：(有则传，具体视业务情况)
                signStatus: 0, //	0-插入insert 1-删除作废
                businessCode: '', //	业务的唯一id
                roles: params.roleCode, //	角色，（与传入的参数roleCode对应）
                teamId: params.teamId, //	小组id（综合实训模式不为null）
                remarkCode: '', //	批量删除标识位（提供给有批量删除埋点需求的业务使用，要保证使用的值是唯一的，如uuid，如：区块链场景下：BlockChainOS-md5(sourceId)）
                environment: '', //	保留字段，埋点接口直接回填即可
                platform: params.platform, //	保留字段，埋点接口直接回填即可
                extend: '', //	保留字段，埋点接口直接回填即可
                orgId: params.deptId,
                token: params.token,
                access_token: rs.data.data.access_token,
              }
              let  iframeUrl = `${host}/?${qs.stringify(param)}`
              window.open(iframeUrl);
            }
            else if (str === "自然人电子税务局（扣缴端）") {
              // 自然人电子税务局（扣缴端）
              let src = `${host}/#login?token=${rs.data.data.access_token}`;
              window.open(src);
            } else if (str === "增值税发票综合服务平台") {

            } else if (str === "区块链发票查询") {

            }

          } else if (myClass == 1) {
            // 正确地址
            // 大数据税务风险预警
            // "https://onlineexcel.cailian.net/#/home?isHide=0&version=V2&universal=undefined&sourceId=MATCH_NONE_2000046273_2_62733000002759&parentPlatform=&token=a92acaa7-5d14-48d3-9196-d1e798424a5c&jsToken=39ab9c2b-e7b4-45c1-ae06-0a19a9386b8f&userId=232699&questionId=77451&platform=SHUIWUFENGXIANfinance&sysId=SWFWYDSJYY&keyId=62733000002759&templateCode=202202003NoSTX&id=3000002759&item=df19d9cb-b8b7-4526-8c51-99228715abcc&orgId=642&orgName=中联教育&encrypted=MATCH_NONE_2000046273_2_62733000002759&username=RC000122760&password=125229&nickname=刘晓庆&idCard=231121199305125229&headImgUrl=&sex=2&userType=2&mobile=18888888888&identity=SHUIWUFENGXIANfinance&roleCodes=8888"
            // 税务风险检查
            // "https://onlineexcel.cailian.net/#/home?isHide=0&version=V2&universal=undefined&sourceId=MATCH_NONE_2000046273_2_62733000002759&parentPlatform=&token=23b82cc6-3ff2-48e1-9f29-18003ca6f9cd&jsToken=39ab9c2b-e7b4-45c1-ae06-0a19a9386b8f&userId=232699&questionId=77436&platform=QIYEZICHAfinance&sysId=SWFWYDSJYY&keyId=62733000002759&templateCode=202202003NoSTX&id=3000002759&item=3a6bfc2f-3253-4ce8-b1e8-c0f1a400861c&orgId=642&orgName=中联教育&encrypted=MATCH_NONE_2000046273_2_62733000002759&username=RC000122760&password=125229&nickname=刘晓庆&idCard=231121199305125229&headImgUrl=&sex=2&userType=2&mobile=18888888888&identity=QIYEZICHAfinance&roleCodes=8888"
            let jumpStr = `isHide=0&version=V2&sourceId=MATCH_NONE_2000046273_2_62733000002759&parentPlatform=managementAccount&token=${rs.data.data.access_token}&userId=${userId}&questionId=${qstId}&platform=${identity}&sysId=SWFWYDSJYY&keyId=${userId}&templateCode=${templateCode}&orgId=${deptId}&orgName=${deptName}&encrypted=${encrypted}&mobile=${mobile}&identity=${identity}&roleCodes=${roleCode}&nickname=${nickname}`;
            let src = `${host}/#home?${jumpStr}`;
            window.open(src);
          }
        } else {
          that.$messageError(rs.data.msg);
        }
      });

    }
  },
};
</script>
<style lang="scss" scoped>
.senior_wrap {
  .taxation_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .taxation_item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    li {
      width: 278px;
      height: 180px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo {
        position: absolute;
        left: 40px;
        top: 48px;
        z-index: 2;
        height: 22px;
      }
      .app_bg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 278px;
        height: 180px;
      }
      button {
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width: 96px;
        height: 34px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(83, 151, 247, 1);
        border-radius: 4px;
        padding: 0;
        color: #5397f7;
        &:hover {
          background: #5397f7;
          color: #fff;
        }
      }
      .text {
        position: absolute;
        left: 32px;
        top: 45%;
        z-index: 2;
        font-size: 16px;
        color: #004e97;
        font-weight: 600;
      }
    }
  }
  /deep/ .el-dialog__header {
    height: 48px;
    background: #edf4ff;
    padding: 20px 15px 0;
    box-sizing: border-box;
    border-radius: 8px 8px 0 0;
  }
  .cont {
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    ul {
      width: 180px;
      margin: 0 auto;
      li {
        font-size: 14px;
        cursor: pointer;
        line-height: 24px;
        text-align: left;
      }
      li.active {
        color: #5397f7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/senior.vue